// extracted by mini-css-extract-plugin
export default {"Container":"style_Container__9pZxN"};